<ng-container>
    <span id="htmlContainer" #htmlContainer>
        @if (form) {
        <div class="w-full float-left">
            <div class="grid grid-cols-4 gap-6 w-full h-full">
                <div class="col-span-4 lg:col-span-2 relative">
                    @if (form?.get('gengi')?.value != '') {
                    <button id="c-downloadButton" (click)="printOrSave()" mat-flat-button type="submit"
                        [color]="'bg-gray-100'">
                        @if (formEnabled) {
                        <span> Prenta / Vista </span>
                        }
                    </button>
                    }
                    <span class="p-8 float-left w-100">
                        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
                            <h2>Skrá gengi</h2>
                            <p>
                                Hér skráir þú gengi fyrir séreignarsjóði LSR. Gengið skráist í réttindakerfið Kríu fyrir
                                valda
                                dagsetningu og sjóð.
                            </p>
                        </div>
                        <span class="separator-line block mb-[30px]"></span>
                        <form [formGroup]="form" #profileInNgForm="ngForm" (keyup.enter)="save()">
                            <div class="grid sm:grid-cols-4 gap-6 w-full">
                                <ng-container>
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="fuse-mat-no-subscript w-full">
                                            <mat-label>Séreignarleið (sjóður)</mat-label>
                                            <mat-select (selectionChange)="onChangeLeid($event.value)"
                                                formControlName="sereignarleid" placeholder="Séreignarleið">
                                                @for (leid of sereignarleidir; track leid) {
                                                <mat-option [value]="leid.value">
                                                    {{ leid.viewValue }}
                                                </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="fuse-mat-no-subscript w-full">
                                            <mat-label>Dagsetning</mat-label>
                                            <input class="date" (dateChange)="onChangeDate($event.value)"
                                                formControlName="dagsetning" matInput placeholder="Dagsetning"
                                                (click)="dagsetning.open()" [matDatepicker]="dagsetning" />
                                            <mat-datepicker-toggle matSuffix [for]="dagsetning"></mat-datepicker-toggle>
                                            <mat-datepicker #dagsetning></mat-datepicker>
                                            @if (this.form?.get('dagsetning')?.hasError('required')) {
                                            <mat-error>
                                                Það
                                                <strong>þarf</strong> að velja dagsetningu
                                            </mat-error>
                                            }
                                        </mat-form-field>
                                    </div>
                                    @if (!skraGengiSimple) {
                                    <div class="col-span-4">
                                        <span class="separator-line block"></span>
                                    </div>
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="fuse-mat-no-subscript w-full">
                                            <mat-label>Markaðsverð eigna</mat-label>
                                            <input id="markadsverd" [formControlName]="'markadsverd'" matInput />
                                            <span matSuffix>ISK</span>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="fuse-mat-no-subscript w-full">
                                            <mat-label>Útistandandi einingar</mat-label>
                                            <input id="utistandandiEiningar" [formControlName]="'utistandandiEiningar'"
                                                matInput />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="fuse-mat-no-subscript w-full">
                                            <mat-label>Viðskipti gærdagsins</mat-label>
                                            <input id="vidskiptiGaerdagsins" numericFormat (keyup)="calculateGengi()"
                                                [formControlName]="'vidskiptiGaerdagsins'" matInput />
                                            <span matSuffix>ISK</span>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="fuse-mat-no-subscript w-full">
                                            <mat-label>Viðbót við markaðsverð</mat-label>
                                            <input id="vidbotVidMarkadsverd" numericFormat (keyup)="calculateGengi()"
                                                [formControlName]="'vidbotVidMarkadsverd'" matInput />
                                            <span matSuffix>ISK</span>
                                        </mat-form-field>
                                    </div>
                                    }
                                </ng-container>
                            </div>
                            @if (skraGengiEnabled) {
                            <span class="fade-in-left flex mt-6 items-center justify-start w-100 float-left w-full">
                                <div class="col-span-4 sm:col-span-2">
                                    <mat-form-field class="w-full">
                                        <mat-label>Gengi</mat-label>
                                        <input id="gengi" [formControlName]="'gengi'" matInput />
                                        @if (!skraGengiSimple) {
                                        <button mat-icon-button matSuffix matTooltip="Afrita gildi"
                                            (click)="copyLink(form.get('gengi').value)">
                                            <mat-icon class="icon-size-5" svgIcon="mat_solid:content_copy"></mat-icon>
                                        </button>
                                        }
                                    </mat-form-field>
                                </div>
                            </span>
                            }
                            @if (skraGengiEnabled) {
                            <div class="fade-in-left flex items-center justify-end mt-[20px] w-full">
                                @if (form.dirty) {
                                <button mat-stroked-button type="button" (click)="revertAllChanges()"
                                    [disabled]="!formEnabled">
                                    {{ 'label_cancel' | translate }}
                                </button>
                                }
                                <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'"
                                    [disabled]="!formEnabled">
                                    @if (formEnabled) {
                                    <span>
                                        {{
                                        thegarHefurVeridSkradGengi
                                        ? 'Uppfæra gengi'
                                        : 'Skrá
                                        gengi'
                                        }}
                                    </span>
                                    }
                                    @if (!formEnabled) {
                                    <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'">
                                    </mat-progress-spinner>
                                    }
                                </button>
                            </div>
                            }
                            <span class="mt-1 block float-right w-100 text-right">
                                @if (thegarHefurVeridSkradGengi) {
                                <span class="fade-in-left text-sm mt-1 tracking-wider text-secondary block">Gengi
                                    <span class="font-semibold">{{ gengiDagsinsSkrad | translocoDecimal }}</span>
                                    hefur þegar verið skráð fyrir valda dagsetningu</span>
                                }
                                @if (thegarHefurVeridSkradGengi) {
                                <span class="separator-line block mb-[5px] mt-[5px]"></span>
                                }
                                @if (sidastaSkradaGengi) {
                                <span class="fade-in-left text-sm tracking-wider text-secondary block">Síðasta gengi
                                    skráð þann {{ formatDate(sidastaSkradaGengi.dagsetning) }}:
                                    <span class="font-semibold">{{ sidastaSkradaGengi.gengi | translocoDecimal
                                        }}</span></span>
                                }
                                @if (mismunurFraSidustuSkraningu) {
                                <span class="fade-in-left text-sm tracking-wider text-secondary block">Mismunur á gengi
                                    frá síðustu skráningu:
                                    <span class="font-semibold" [ngClass]="{
                                                    'alert-safe-bg': checkTotalGengiAlert(mismunurFraSidustuSkraningu),
                                                }">{{ toFixed((1 - mismunurFraSidustuSkraningu) * -100, 4) |
                                        translocoDecimal }} %</span></span>
                                }
                            </span>
                        </form>
                    </span>
                </div>
                <div [ngClass]="{
                            hidden: displayedData?.data?.length <= 0 || skraGengiSimple,
                        }" id="tableContainerParent" class="fade-in-left col-span-4 lg:col-span-2 border-l ml-2">
                    <div id="tableContainer" class="w-full sm:w-auto float-left w-full bg-basic-gray overflow-x-auto">
                        <div id="header"
                            class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 pb-4 md:px-8 border-b">
                            <div class="absolute top-1 right-2 mt-2 font-medium text-secondary float-right text-right"
                                *ngIf="form.get('dagsetning').value">
                                Viðmiðunardagsetning:
                                {{ getCalendarTwoDaysBeforeOrThursday(form.get('dagsetning').value) | date:
                                'dd.MM.yyyy'}}
                                <br />
                                Markaðsdagsetning:
                                {{ getCalendarPreviousDayOrFriday(form.get('dagsetning').value) | date: 'dd.MM.yyyy' }}
                            </div>
                            <!-- Title -->
                            <div>
                                <div class="prose prose-sm col-span-4">
                                    <h2>
                                        {{ form?.get('sereignarleid')?.value }}
                                        - Eignir í eignasafni
                                    </h2>
                                </div>
                                <div class="ml-0.5 font-medium text-secondary">
                                    @if (displayedData.filteredData.length > 0) {
                                    {{ displayedData.filteredData.length }}
                                    }
                                    {{
                                    displayedData.filteredData.length
                                    | i18nPlural
                                    : {
                                    '=0': 'Engar eignir fundust',
                                    '=1': 'eign',
                                    other: 'eignir',
                                    }
                                    }}
                                </div>
                            </div>
                            <!-- Main actions -->
                            <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                                <!-- Search -->
                                <div class="flex-auto">
                                    <mat-form-field
                                        class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'">
                                        </mat-icon>
                                        <input matInput placeholder="Leita"
                                            (keyup)="searchFilter($event.target.value)" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData">
                            <ng-container matColumnDef="symbol">
                                <th mat-sort-header="symbol" mat-header-cell *matHeaderCellDef>Eign</th>
                                <td mat-cell [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }" *matCellDef="let element">
                                    {{ element.symbol }} -
                                    {{ element.symbolName }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="marketValueToday">
                                <th mat-sort-header="marketValueToday" mat-header-cell *matHeaderCellDef>Markaðsverð
                                    dagsins (ISK)</th>
                                <td mat-cell [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }" *matCellDef="let element">
                                    {{ element.marketValueToday | translocoDecimal }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="marketValueBefore">
                                <th mat-sort-header="marketValueBefore" mat-header-cell *matHeaderCellDef>
                                    Markaðsverð viðmiðunardags (ISK)
                                </th>
                                <td mat-cell [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }" *matCellDef="let element">
                                    {{ element.marketValueBefore | translocoDecimal }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="closingPriceToday">
                                <th mat-sort-header="closingPriceToday" mat-header-cell *matHeaderCellDef>Gengi í gær
                                </th>
                                <td mat-cell [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }" *matCellDef="let element">
                                    {{ element.closingPriceToday | translocoDecimal }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="closingPriceBefore">
                                <th mat-sort-header="closingPriceBefore" mat-header-cell *matHeaderCellDef>Gengi
                                    viðmiðunardags</th>
                                <td mat-cell [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }" *matCellDef="let element">
                                    {{ element.closingPriceBefore | translocoDecimal }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="closingPriceDifference">
                                <th [matTooltip]="'Breyting milli daga'" mat-sort-header="closingPriceDifference"
                                    mat-header-cell *matHeaderCellDef>
                                    Br.m.d. (%)
                                </th>
                                <td mat-cell [ngClass]="{
                                            'alert-safe-bg': checkGengiAlert(element.closingPriceDifference),
                                        }" *matCellDef="let element">
                                    {{
                                    element.closingPriceDifference == 0
                                    ? 0
                                    : (toFixed(100 - element.closingPriceDifference * 100, 4) * -1 | translocoDecimal)
                                    }}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: headerColumns"></tr>
                            <tr class="mat-row" *matNoDataRow>
                                @if (loaded) {
                                <div class="flex items-center justify-between">
                                    <span>
                                        <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">Engir sjóðir fundust
                                        </div>
                                    </span>
                                </div>
                                }
                            </tr>
                        </table>
                        <mat-paginator #tablePaginator class="justify-end" showFirstLastButtons [pageSize]="50"
                            [pageSizeOptions]="[10, 25, 50, 100]">
                        </mat-paginator>
                    </div>
                </div>
            </div>
        </div>
        }
    </span>
</ng-container>